import Banners from 'bv-banners';

const HomeComponentsBanners = () => (
  <div className="site-top-banner-wrapper">
    <Banners location="Home" />
  </div>
);

export default HomeComponentsBanners;
